import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { desktopVW, mobileVW } from '../../styles/'
import theme from '../../styles/theme'

export default function Input({
  inputValue: value,
  inputSetValue: setValue,
  inputType,
  inputName,
  placeholder,
  onChangecallback,
  validation,
  setContainErrors,
  height,
  required,
}) {
  const [isFocused, setIsFocused] = useState(false)
  const [isError, setIsError] = useState(false)

  const handleChange = (e) => {
    setValue(e.target.value)
    onChangecallback(e)
  }

  useEffect(() => {
    if (!isFocused) {
      if (value?.length > 0) {
        switch (validation) {
          case 'noValidation':
            setIsError(false)
            setContainErrors(false)
            break
          case 'onlyLetters':
            if (!/^[a-zA-Z\s]*$/.test(value)) {
              setIsError(true)
              setContainErrors(true)
            } else {
              setIsError(false)
              setContainErrors(false)
            }
            break
          case 'onlyNumbers':
            if (!/^[0-9\s]*$/.test(value)) {
              setIsError(true)
              setContainErrors(true)
            } else {
              setIsError(false)
              setContainErrors(false)
            }
            break
          case 'onlyEmail':
            if (value.length > 0) {
              if (
                !/^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,10})$/.test(
                  value,
                )
              ) {
                setIsError(true)
                setContainErrors(true)
              } else {
                setIsError(false)
                setContainErrors(false)
              }
            }
            break
          case 'password':
            if (value.length > 0) {
              if (
                /^.*(?=.{6,20})(?=.*[a-z])(?=.*[A-Z]).*$/.test(value) === false
              ) {
                //(?=.*\d)
                setIsError(true)
                setContainErrors(true)
              } else {
                setIsError(false)
                setContainErrors(false)
              }
            }
            break
        }
      } else {
        setIsError(false)
        setContainErrors(true)
      }
    }
  }, [isFocused])

  const errorText = () => {
    if (validation === 'onlyLetters') {
      return 'Please enter only latin letters'
    }
    if (validation === 'onlyEmail') {
      return 'Please enter a valid email'
    }
    if (validation === 'onlyNumbers') {
      return 'Please enter a valid phone number'
    }
    if (validation === 'password') {
      return 'At least 6 characters with 1 capital letter'
    }
  }

  return (
    <>
      <Wrapper>
        <StyledInput
          type={inputType}
          name={inputName}
          placeholder={placeholder}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          required={required}
          isFocused={isFocused}
          value={value}
          autoComplete='off'
          height={height}
        />
      </Wrapper>
      <ErrorMsg validation={validation} isError={isError} isFocused={isFocused}>
        {errorText()}
      </ErrorMsg>
    </>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`

const StyledInput = styled.input`
  justify-content: center;
  align-items: center;
  border: 1px solid #ececec;
  height: ${mobileVW(60)};
  width: 100%;
  font-size: ${mobileVW(12)}!important;
  font-family: inherit !important;
  padding-left: ${mobileVW(30)};
  margin: ${mobileVW(5)} 0;
  @media (min-width: ${theme.breakPoints.desktop}) {
    margin: ${desktopVW(10, 1440)} 0;
    height: ${desktopVW(60, 1440)};
    font-size: ${desktopVW(12, 1440)}!important;
    padding-left: ${desktopVW(30, 1440)};
  }
  ::placeholder {
    color: ${theme.colors.darkGrey}!important;

    @media (min-width: ${theme.breakPoints.desktop}) {
      color: ${theme.colors.darkGrey}!important;
    }
  }
`

const ErrorMsg = styled.p`
  align-self: flex-start;
  display: ${(props) => (props.isError ? 'block' : 'none')};
  color: ${theme.colors.daily};
  font-size: ${theme.fontSize.m30}!important;
  padding: ${mobileVW(5)} 0;
  @media (min-width: ${theme.breakPoints.desktop}) {
    padding: 0 ${desktopVW(15, 1440)};
    font-size: ${theme.fontSize.d15}!important;
  }
`
